<!-- 404页面 -->
<template>
  <div
    class="exception"
    :style="Height"
  >
    <div class="imgBlock">
      <div class="imgEle" />
    </div>
    <div class="content">
      <h1>404</h1>
      <div class="desc">
        抱歉，你访问的页面不存在或仍在开发中
      </div>
      <div class="actions">
        <el-button
          type="primary"
          @click="handleToHome"
        >
          返回首页
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {}
  },
  computed: {
    Height() {
      const h = window.innerHeight - 200
      return `height: ${h}px`
    }
  },
  methods: {
    handleToHome() {
      this.$router.push('/')
    }
  }
}
</script>
 <style scoped>
 .exception{ text-align: center; padding: 100px 30px;}
 .exception h1{ font-size: 100px;}
 .desc{margin-bottom: 30px;}

 </style>
